module.exports = __webpack_public_path__ + "img/logo_arab.69a85ada.svg";